module.exports = __webpack_public_path__ + "img/3.92220315.png";